var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataList',{attrs:{"dataList":_vm.fileList,"showType":"CardList","contentType":"photo","linkPattern":"/news/photo/{id}","totalCount":_vm.count,"hasPagination":true,"pageSize":_vm.size},on:{"handlePageChange":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }